<template>
  <div class="system-title">
    <!-- <div class="system-title-text" v-if="isExpand">{{ subSystemName }}</div> -->
  </div>
  <div class="system-menu">
    <div class="menu-list" v-if="isExpand">
      <el-scrollbar>
        <el-menu
          :default-active="activeMenu"
          text-color="#fff"
          active-color="#fff"
          unique-opened
        >
          <sysytemSubMenu :menus="menus"></sysytemSubMenu>
        </el-menu>
      </el-scrollbar>
      <div class="logo_box">
        <el-image :src="require('@/assets/images/color_back.png')" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  getCurrentInstance,
  toRefs,
  onMounted,
  ref,
  watch,
  computed,
  nextTick
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "sysytemMenu",
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();

    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      isExpand: true,
      menus: [
        // {
        //   name: "user",
        //   path: "/userCenter/user",
        //   hidden: false,
        //   meta: {
        //     title: "用户管理",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
        // {
        //   name: "post",
        //   path: "/userCenter/post",
        //   hidden: false,
        //   meta: {
        //     title: "岗位管理",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
        // {
        //   name: "role",
        //   path: "/userCenter/role",
        //   hidden: false,
        //   meta: {
        //     title: "角色管理",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
        // {
        //   name: "dept",
        //   path: "/userCenter/dept",
        //   hidden: false,
        //   meta: {
        //     title: "部门管理",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
        // {
        //   name: "menu",
        //   path: "/userCenter/menu",
        //   hidden: false,
        //   meta: {
        //     title: "菜单管理",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
        // {
        //   name: "dictType",
        //   path: "/userCenter/dictType",
        //   hidden: false,
        //   meta: {
        //     title: "字典类型",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
        // {
        //   name: "dictData",
        //   path: "/userCenter/dictData",
        //   hidden: false,
        //   meta: {
        //     title: "字典数据",
        //     icon: "aqscgl",
        //     noCache: false,
        //     link: null,
        //   },
        // },
      ],
      systemList: []
    });
    const subSystemName = computed(() => store.getters.subSystemName);
    const subSystemId = computed(() => store.getters.subSystemId);

    const clickExpand = () => {
      state.isExpand = !state.isExpand;
      emit("expand", state.isExpand);
    };
    onMounted(() => {
      getSystemList();
    });
    const getSystemList = () => {
      state.systemList = [];
      if (store.getters.userInfo) {
        if (store.getters.userInfo.menuTree.length > 0) {
          if (store.getters.userInfo.menuTree[0].menuCode == "1") {
            state.systemList =
              store.getters.userInfo.menuTree[0]?.children ?? [];
          } else {
            store.getters.userInfo.menuTree.forEach((item) => {
              if (item.menuCode !== "1" && item.menuType.value === "M") {
                state.systemList.push(item);
              }
            });
          }
        }
      } else {
        state.systemList = [];
      }
      if (sessionStorage.getItem("subSystemId")) {
        if (sessionStorage.getItem("subSystemId") !== subSystemId.value) {
          store.commit(
            "permission/SET_SUB_SYSTEM_ID",
            sessionStorage.getItem("subSystemId")
          );
        } else {
          let obj = state.systemList.find(
            (item) => sessionStorage.getItem("subSystemId") === item.menuCode
          );
          clickSystem(obj);
        }
      } else {
        if (state.systemList[0]) {
          clickSystem(state.systemList[0]);
        }
      }
    };
    const activeMenu = computed(() => {
      return route.path;
    });
    watch(
      () => subSystemId.value,
      (n) => {
        if (n) {
          let obj = state.systemList.find((item) => n === item.menuCode);
          clickSystem(obj);
        }
      }
    );
    /** 点击系统 */
    const clickSystem = (sys) => {
      const routeTabs = store.getters.routeTabs;
      state.menus = [];
      if (sys.menuType.value === "M") {
        //菜单类型为目录时
        if (sys.children && sys.children.length > 0) {
          state.menus = getMenus(sys.children, sys.menuCode);
        }
        store.commit("permission/SET_SUB_SYSTEM_NAME", sys.menuName);
        //先判断tabs里面是否当前菜单，有就代表发生跳转，不用去默认跳第一个
        const routeTabsPath = routeTabs.map((item) => {
          return item.path;
        });
        let inTabs = false;
        if (routeTabsPath && routeTabsPath.length > 0) {
          inTabs = findInTabs(state.menus, routeTabsPath);
        }
        //
        if (state.menus[0] && !inTabs) {
          const noJump = pathInMenus(state.menus, route.path);
          const menus = noJump ? noJump : findPath(state.menus[0]);
          const index = routeTabs.findIndex(
            (route) => menus.path === route.path
          );
          if (index < 0) {
            routeTabs.push(menus);
          }
          setTimeout(() => {
            router.push(menus.path);
          }, 50);
          store.commit("permission/SET_ROUTE_TABS", routeTabs);
        }
      } else if (sys.menuType.value === "C") {
        //菜单类型为菜单时
        if (sys.frongRoute) {
          router.push(sys.frongRoute);
        } else {
          proxy.$message.warning("当前菜单未绑定路由");
        }
      }
    };
    /** 处理系统菜单数据 */
    const getMenus = (data, menuCode) => {
      let arr = [];
      data.forEach((item) => {
        if (item.menuType.value !== "F" && item.visible.value == 0) {
          let obj = {
            name: item.menuName,
            path: item.frongRoute ? item.frongRoute : null,
            hidden: false,
            meta: {
              title: item.menuName,
              icon: item.icon,
              noCache: false,
              link: null
            },
            children: null,
            menuCode: menuCode,
            isFrame: item.isFrame
          };
          if (item.children && item.children.length > 0) {
            obj.children = getMenus(item.children, menuCode);
          }
          arr.push(obj);
        }
      });
      return arr;
    };
    /* 查找跳转的路径 */
    const findPath = (data) => {
      if (data.path) {
        return data;
      } else if (data.children && data.children.length > 0) {
        return findPath(data.children[0]);
      }
    };
    /*判断当前路径是否属于当前系统*/
    const pathInMenus = (menus, path) => {
      let boo = null;
      menus.forEach((item) => {
        if (item.path === path) {
          boo = item;
        } else if (menus.children && menus.children.length > 0) {
          boo = pathInMenus(menus.children, path);
        }
      });
      return boo;
    };
    /**/
    const findInTabs = (menus, tabs) => {
      let boo = false;
      menus.forEach((item) => {
        if (!boo) {
          if (item.path && tabs.indexOf(item.path) > -1) {
            boo = true;
          } else if (item.children && item.children.length > 0) {
            boo = findInTabs(item.children, tabs);
          }
        }
      });
      return boo;
    };
    return {
      ...toRefs(state),
      subSystemName,
      clickExpand,
      activeMenu,
      clickSystem,
      getMenus
    };
  }
});
</script>

<style lang="less" scoped>
.system-title {
  height: 8px;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(9, 28, 63, 0.07) 0%,
    rgba(9, 28, 63, 0.21) 13.02%,
    rgba(9, 28, 63, 0.21) 19.79%,
    rgba(9, 28, 63, 0) 100%
  );
  .system-title-icon {
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .system-title-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bolder;
    font-size: 14px;
    margin-left: 20px;
  }
}
.system-menu {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: calc(100% - 40px);

  .system-list {
    width: 50px;
    height: 100%;
    display: inline-block;
    border-right: 1px solid #f0f0f0;
    .system-item {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-wrap: wrap;
    }
  }
  .menu-list {
    height: 100%;
    display: inline-block;
    vertical-align: bottom;
    width: 100%;
  }
}
.menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-wrap: wrap;
}

::v-deep .el-menu {
  background: #37507e;
}
.menuName {
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  font-size: 12px;
  width: 100%;
}

::v-deep .el-menu-item:hover {
  background: linear-gradient(90deg, #3868bf 0%, rgba(56, 104, 191, 0) 100%);
}
::v-deep .el-sub-menu__title {
  color: #fff;
}
::v-deep .el-sub-menu__title:hover {
  background: linear-gradient(90deg, #3868bf 0%, rgba(56, 104, 191, 0) 100%);
}
::v-deep .el-sub-menu__icon-arrow {
  color: #fff;
}

::v-deep .is-active {
  background: linear-gradient(90deg, #3868bf 0%, rgba(56, 104, 191, 0) 100%);
}

::v-deep .is-opened {
  // 用于覆盖sub-menu 选中状态重复问题
  background: #37507e;
}
.logo_box {
  height: 22px;
  display: flex;
  justify-content: center;
}
</style>
<style lang="less">
.menu-list {
  .el-menu {
    border: none;
  }
}
</style>
